<template>
    <vs-button
        :disabled="statusId >= 2"
        id="btn-status"
        class="mr-2 vs-con-loading__container"
        type="relief" 
        color="success"
        @click="changeStatus(statusId)"
        @mouseenter="() => show.btnStatus = true"
        @mouseleave="() => show.btnStatus = false"
        > 
        <a-icon type="bell" style="font-size: 15px" />  {{ show.btnStatus ? (getStatus(statusId)) : '' }}  
    </vs-button>
    <!-- <vs-button class="w-full" type="border" @click="cancelOrder()">{{ $t('cancelOrder').toUpperCase() }}</vs-button> -->
</template>

<script>
    import { httpsCallable } from "@/firebase/functions";

    export default {
        props : {
            statusId : Number,
            billId : {
                type : String,
                required : true,
            },
        },

        data () {
            return {
                show : {
                    btnStatus : false
                }
            }
        },

        methods : {
            async changeStatus (id) {
                const companyId = this.$store.getters.getCompanyID
                try {
                    const newId = id == 1 ? id+2 : id+1 // desconsidera o status de "em produção"
                    this.$vs.loading({ container: '#btn-status', scale : 0.5 });
                    const call = httpsCallable('updateBillStatus')
                    await call({companyId: companyId, billId: this.billId, status : newId})
                    this.$message.success(`Status do pedido atualizado!`)
                } catch (err) {
                    this.$error({
                        okType : 'danger',
                        title: 'Erro ao tentar alterar status',
                        content : `Erro: ${err.message}`,
                        zIndex : 999999
                    })
                } finally {
                     this.$vs.loading.close('#btn-status > .con-vs-loading');
                }
            },

            getStatus (id) {
                const status = ['Aceitar Pedido', 'Concluir Pedido']
                return status[id]
            },

            cancelOrder () {
                let that = this
                let companyId = this.$store.getters.getCompanyID

                this.$confirm({
                    zIndex : 999999,
                    title: this.$t('confirmYourIntention'),
                    content: this.$t('reallyRemoveBill'),
                    okText : this.$t('yesCancelBill'),
                    cancelText : this.$t('no'),
                    okType: 'danger',
                    async onOk () {
                        try {
                            that.$vs.loading()
                            let call = httpsCallable('cancelBill')
                            await call({ companyId : companyId, billId: that.billId })
                        } catch (err) {
                            that.$error({
                                zIndex : 999999,
                                title: that.$t('cancelError'),
                                content: `${that.$t('errorWhileCancelingBill')} ${err.message}`
                            })
                        } finally {
                            that.$vs.loading.close()
                        }
                    }
                })
            }
        }
    }
</script>